export const ENDPOINTS = {
    ACCOUNTANT: {
        GET: '/accountant/:accountantId',
    },
    ACCOUNTANT_MEETINGS: {
        POST: '/accountantmeetings',
        GET: {
            SINGLE: '/accountantmeetings/:accountantMeetingId',
            LIST: '/accountantmeetings',
        },
        PUT: {
            UPDATE: '/accountantmeetings/:accountantMeetingId',
            UPDATE_STATUS: '/accountantmeetings/:accountantMeetingId/status/:status',
        },
        DELETE: '/accountantmeetings/:accountantMeetingId',
    },
    ADDITIONAL_CHARGES: {
        GET: {
            UNPAID: '/additionalcharges/unpaid',
        },
    },
    AGENT_AUTHORISATION: {
        GET: '/agentauthorisation',
        PUT: '/agentauthorisation/:agentAuthorisationId',
    },
    COMPANIES_HOUSE: {
        GET: {
            SEARCH: '/companieshouse/search',
        },
    },
    COMPANIES: {
        GET: {
            LIST: '/companies',
            SINGLE: '/companies/:companyId',
        },
        POST: '/companies',
        PUT: {
            ACTING_ON_BEHALF: '/companies/:companyId/isuseractingonbehalfofdirectors/:isUserActingOnBehalfOfDirectors',
            COMPANY_NUMBER: '/companies/:companyId/companynumber/:companyNumber',
            UPDATE_COMPANY: '/companies/:companyId',
        },
    },
    COMPANY_OFFICERS: {
        GET: {
            LIST: '/companies/:companyId/officers',
            SINGLE: '/companies/:companyId/officers/:companyOfficerId',
        },
        POST: {
            SEND_EMAIL: '/companies/:companyId/officers/:companyOfficerId/sendkycinvite',
        },
        PUT: {
            SINGLE: '/companies/:companyId/officers/:companyOfficerId',
            SINGLE_IS_PRIMARY: '/companies/:companyId/officers/:companyOfficerId/isprimary/:isPrimary',
        },
    },
    COMPANY_RETURNS: {
        GET: {
            SINGLE: '/companies/:companyId/returns/:companyReturnId',
            LIST: '/companies/:companyId/returns',
            PRICE: '/companies/:companyId/returns/:companyReturnId/pricing',
            AGREEMENT: '/companies/:companyId/returns/:companyReturnId/agreement',
        },
        POST: {
            CREATE_RETURN: '/companies/:companyId/returns',
            ASSIGN_ACCOUNTANT: '/companies/:companyId/returns/:companyReturnId/accountant',
        },
        PUT: {
            UPDATE_DATES: '/companies/:companyId/returns/:companyReturnId/dates',
            UPDATE_RETURN: '/companies/:companyId/returns/:companyReturnId',
            UPDATE_STATUS: '/companies/:companyId/returns/:companyReturnId/status/:newStatus',
        },
        DELETE: {
            SINGLE: '/companies/:companyId/returns/:companyReturnId',
        },
    },
    COMPANY_RETURN_FILES: {
        GET: {
            LIST: '/companies/:companyId/returns/:companyReturnId/files',
            DOWNLOAD_FILE: '/companies/:companyId/returns/:companyReturnId/files/:fileId/downloadlink',
        },
        POST: '/companies/:companyId/returns/:companyReturnId/files',
        DELETE: '/companies/:companyId/returns/:companyReturnId/files/:fileId',
    },
    OFF_PLATFORM_SERVICE_REQUEST: {
        GET: {
            SINGLE: '/offplatformservicerequests/:id',
            LIST: '/offplatformservicerequests',
        },
        POST: '/offplatformservicerequests',
        PUT: '/offplatformservicerequests/:id',
    },
    PARTNER: {
        GET: {
            SINGLE: '/partner/:userId',
        },
        PUT: {
            UPDATE: '/partner/:userId',
        },
        POST: {
            REFER: '/partner/:userId/refer',
        },
    },
    PAYMENT: {
        POST: {
            ONE_OFF_CHECKOUT: '/payment/paymentrequest/checkout',
            REQUEST_INTENT: '/payment/paymentrequest/paymentintent',
            SUBSCRIPTION_CHECKOUT: '/payment/subscriptionpaymentrequest/checkout',
        },
    },
    PUSH_NOTIFICATIONS: {
        PUT: {
            ON: '/mobiledevices/pushnotifications/on',
            OFF: '/mobiledevices/pushnotifications/off',
        },
    },
    REFERRALS: {
        GET: {
            ALL: `/user/:userId/referrals`,
        },
        POST: {
            EMAIL: '/referral/email',
            EMAILS: '/referral/emails',
        },
    },
    SELF_ASSESSMENT: {
        GET: {
            PRICE: '/selfassessment/:selfAssessmentId/pricing',
            PRICING_TIERS: '/selfassessment/:selfAssessmentId/pricing/tiers',
        },
        PUT: {
            TIER: '/selfassessment/:selfAssessmentId/tier',
        },
    },
    SUBSCRIPTIONS: {
        GET: {
            ACTIVE: '/subscriptions',
            PAYMENTS: '/subscriptions/:subscriptionId/payments',
            TIERS: '/subscriptions/tiers',
            AGREEMENT: '/subscriptions/:subscriptionId/agreement',
        },
        POST: {
            CREATE: '/subscriptions',
            INITIATE_PAYMENT: '/subscriptions/subscriptionpayment',
            CONFIRM_PAYMENT: '/subscriptions/subscriptionconfirmation/:sessionId',
            ASSIGN_ACCOUNTANT: '/subscriptions/:subscriptionId/accountant',
        },
        PUT: {
            CANCEL: '/subscriptions/:subscriptionId',
        },
    },
    TAX_CONSULTATIONS: {
        GET: {
            PRICE: '/taxconsultations/:taxConsultationId/pricing',
        },
    },
    TAX_REGISTRATION: {
        GET: '/taxregistration/:userId',
    },
    TAX_RELIEF_CLAIMS: {
        GET: {
            SINGLE: '/taxReliefClaims/:taxReliefClaimId',
            ALL: '/taxReliefClaims',
            FILES: '/taxReliefClaims/:taxReliefClaimId/files',
            DOWNLOAD_FILE: '/taxReliefClaims/:taxReliefClaimId/files/:taxReliefClaimFileId/downloadLink',
        },
        POST: {
            CREATE_ID: '/taxReliefClaims',
            UPLOAD_CERTIFICATE: '/taxReliefClaims/:taxReliefClaimId/files',
        },
        DELETE: {
            DELETE_TAX_RELIEF_CLAIM: '/taxReliefClaims/:taxReliefClaimId',
            DELETE_CERTIFICATE: '/taxReliefClaims/:taxReliefClaimId/files/:taxReliefClaimFileId',
        },
        PUT: {
            UPDATE_CERTIFICATE: '/taxReliefClaims/:taxReliefClaimId/files/:taxReliefClaimFileId',
            UPDATE_TAX_RELIEF_CLAIM: '/taxReliefClaims/:taxReliefClaimId',
            UPDATE_STATUS: '/taxReliefClaims/:taxReliefClaimId/status/:taxReliefClaimStatus',
        },
    },
    TAX_RETURNS: {
        GET: {
            SINGLE: '/selfassessment/:taxReturnId',
            REASONS: '/selfassessment/:taxReturnId/reasons',
        },
        POST: {
            CREATE: '/selfassessment',
        },
        PUT: {
            ASSIGN_ACCOUNTANT: '/selfassessment/:taxReturnId/accountant',
            UPDATE: '/selfassessment/:taxReturnId',
            UPDATE_STATUS: '/selfassessment/:taxReturnId/status/:newStatus',
        },
    },
    TAX_RETURN_REASONS: {
        PUT: {
            UPDATE: '/selfassessment/:taxReturnId/reason',
        },
        DELETE: {
            SINGLE: '/selfassessment/:taxReturnId/reason',
        },
    },

    TAX_RETURN_CAPITAL_GAINS: {
        GET: {
            SINGLE: '/capitalgains/:taxReturnId',
        },
        PUT: {
            UPSERT: '/capitalgains/:taxReturnId',
        },
    },
    TAX_RETURN_DIVIDENDS_AND_INTERESTS: {
        GET: {
            SINGLE: '/dividendsandinterest/:taxReturnId',
        },
        PUT: {
            UPSERT: '/dividendsandinterest/:taxReturnId',
        },
    },
    TAX_RETURN_FOREIGN_INCOME_SUMMARY: {
        GET: {
            SINGLE: '/foreignincomesummary/:taxReturnId',
        },
        PUT: {
            UPSERT: '/foreignincomesummary/:taxReturnId',
        },
    },
    TAX_RETURN_PENSIONS_AND_BENEFITS: {
        GET: {
            SINGLE: '/pensionsandbenefits/:taxReturnId',
        },
        PUT: {
            UPSERT: '/pensionsandbenefits/:taxReturnId',
        },
    },
    TAX_RETURN_PROPERTY_INCOME: {
        GET: {
            SINGLE: '/propertyincome/:taxReturnId',
        },
        PUT: {
            UPSERT: '/propertyincome/:taxReturnId',
        },
    },
    TAX_RETURN_SELF_EMPLOYMENT: {
        GET: {
            SINGLE: '/selfemployment/:taxReturnId',
            EXPENSES: '/selfemployment/:taxReturnId/selfemploymentexpenses',
        },
        PUT: {
            UPSERT: '/selfemployment/:taxReturnId',
        },
    },
    TAX_RETURN_SELF_EMPLOYMENT_EXPENSES: {
        POST: {
            CREATE: '/selfemploymentexpense',
        },
        DELETE: '/selfemploymentexpense/:selfEmployedExpenseId',
    },

    USER: {
        POST: {
            LOGGED_IN: '/user/loggedin',
            REQUEST_PHONE_CALL: '/user/:userId/callme',
            HOT_LEAD: '/user/:userId/hotlead',
        },
        GET: {
            SINGLE: '/user/:userId',
        },
        PUT: '/user/:userId',
    },
    USER_SEGMENTS: {
        GET: '/usersegments/:userId',
    },
    UNREGISTERED_USER: {
        GET: '/user/unregistered',
        POST: {
            CREATE_UNREGISTERED_TOKEN: '/user/unregistered/token',
            HOT_LEAD: '/user/unregistered/hotlead',
        },
        PUT: '/user/unregistered',
    },
    USER_AGREEMENTS: {
        POST: {
            CREATE: '/useragreements',
            DRAFT: '/useragreements/draft',
        },
    },
    USER_DISCOUNT: {
        GET: {
            ALL: '/userdiscount',
            SINGLE: '/userdiscount/:userDiscountId',
        },
        POST: '/userdiscount',
    },
    USER_EXPERIMENTS: {
        POST: '/userexperiments',
        GET: '/userexperiments/:userExperimentId',
    },
} as const
